import { ITranslationEntry } from '@modeso/types__aumico-lib-annualreport-be';
import { GapReportingVisitor } from './GapReportingVisitor';
import { ITranslatorVisitor } from './ITranslatorVisitor.interface';
import { UntranslatedTexts } from './UntranslatedTexts';
import { ComplementaryReports } from './classes/ComplementaryReports';

export class ComplementaryReportsTranslatorVisitor extends GapReportingVisitor implements ITranslatorVisitor {
    constructor(untranslated?: UntranslatedTexts, translations?: Record<string, ITranslationEntry>) {
        super(untranslated, 'complementary', translations);
    }

    visit(reports: ComplementaryReports): void {
        // Free user content without a template or a locale field, so both fields are always a gap.
        // fileName stays out: it names an uploaded file, not running text of the report.
        reports.complementaryReports.forEach((report) => {
            report.title = this.resolve(report.title);
            report.content = this.resolve(report.content);
        });
    }
}
